<template>
  <div>404 not found</div>
</template>

<script>
export default {
  name: "notfound",
  computed: {},
  mounted() {
    this.$router.push({ name: "Main" });
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
</style>



// WEBPACK FOOTER //
// src/components/Pages/NotFound.vue